<template>
  <div class="grid text-left pr-5">
    <div class="grid gap-3 grow self-start">
      <h5 class="h5 !font-bold self-start">Upgrade your plan</h5>
    </div>
    <div class="self-end">
      <p v-if="loading" class="otivo-error-message mx-auto">Loading tiers</p>
      <div
        v-for="({ value_tier, price, product }, index) in sortedTiers"
        :key="index"
        :class="
          selectedTier?.value_tier === value_tier ? 'bg-blue-5 border-primary' : 'border-grey-4'
        "
        class="p-4 rounded shadow-lg text-blue-1 cursor-pointer border my-4 text-left flex space-x-2 relative"
        @click="selectTier(value_tier)">
        <div
          v-if="value_tier === 'basic'"
          class="absolute -top-4 right-4 rounded-full text-white py-2 text-sm font-bold bg-primary px-8">
          Recommended
        </div>
        <svg
          v-if="value_tier === selectedTier?.value_tier"
          class="grow-0 mt-[2px] size-5"
          fill="none"
          viewBox="0 0 20 20">
          <circle cx="10" cy="10" fill="#0064FF" r="10" />
          <circle cx="10" cy="10" fill="white" r="4" />
        </svg>
        <svg v-else class="grow-0 mt-[2px] size-5" fill="none" viewBox="0 0 20 20">
          <circle cx="10" cy="10" fill="white" r="9.5" stroke="#A0A0A0" />
        </svg>
        <div class="flex flex-col space-y-2 grow">
          <p>{{ product.name }}</p>
          <div>
            <span class="mh2">{{ formattedPrice(price.amount) }}</span> per
            {{ price.interval }}
          </div>
        </div>
      </div>
      <div
        class="border border-grey-4 bg-white rounded text-sm text-grey-1 overflow-hidden h-full flex flex-col">
        <div class="p-4 text-mp1 flex-1 min-h-[360px]">
          <AnnualFeatureList v-if="selectedTier?.value_tier === 'basic'" />
          <AnnualPlusFeatureList v-if="selectedTier?.value_tier === 'plus'" />
        </div>
      </div>
      <OtivoButton :disabled="!selectedTier" class="w-full mt-8" @click="next">Next </OtivoButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { PlanTier } from '@/composables/useTieredPlans.ts'
import OtivoButton from '@/components/OtivoButton.vue'
import AnnualFeatureList from '@/app/components/pricing/AnnualFeatureList.vue'
import AnnualPlusFeatureList from '@/app/components/pricing/AnnualPlusFeatureList.vue'

type Props = {
  tiers: PlanTier[]
  selectedTier: PlanTier | null
  loading: boolean
}

type Emits = {
  selectTier: [tierValue: string]
  next: [selectedTier: PlanTier]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const sortedTiers = computed(() => [...props.tiers].sort((a, b) => a.price.amount - b.price.amount))

const formattedPrice = (price: number) => {
  return (
    (price / 100).toLocaleString('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
    }) ?? 0
  )
}

const selectTier = (value_tier: string) => {
  emit('selectTier', value_tier)
}

const next = () => {
  if (props.selectedTier) {
    emit('next', props.selectedTier)
  }
}
</script>

<style scoped></style>
